module.exports = __webpack_public_path__ + "static/03-5228f5ca38815ab27f6f1764c7c22fb6.png";